(function ($, document, window, undefined) {

    const swiper = new Swiper('.swiper-container', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        }
        
      });

      
    const Form = function(){
        
      const labelHandler = function(e) {

        console.dir(e);

        const parent = e.target.closest(".gfield");

        if(e.type == "focusin" || e.type == "change" || e.target.value.length >= 1) 
          parent.querySelector(".gfield_label").style.display = "none";
        else if( e.target.value.length == 0 )
          parent.querySelector(".gfield_label").style.display = "block";
        
      }

      return { labelHandler }
	
    }();
    


    const Globals = function() {

      const seeMore = function(e) {

        const elem = e.target;
        const parentDiv = elem.closest("div");

        if(! parentDiv.classList.contains("is-expanded")) {
          elem.text = "See less";
          elem.closest("div").lastElementChild.appendChild(elem);
          parentDiv.classList.add("is-expanded");
        }
        else {
          elem.text = "See more";
          elem.closest("div").firstElementChild.appendChild(elem);
          parentDiv.classList.remove("is-expanded");
        }
        
      }
      
      const toggleMenu = function() {
        
        const menuToggle = document.querySelector("[data-js=toggleMenu]");
        const menu = document.querySelector("header nav");

        if(window.getComputedStyle(menu).display == "flex") {
          menu.style.display = "none";
          menuToggle.classList.remove("is-active");
        }
        else {
          menu.style.display = "flex";
          menuToggle.classList.add("is-active");
        }
      }

      const openModal = function(e) {

          const modal = e.target.getAttribute('data-modal');
          MicroModal.show(modal);
      }

      return { toggleMenu, seeMore, openModal };
    }();

    if ( !window.Galea ) window.Galea = {};
      window.Galea.Globals = Globals;

    
        
    /* START DOMContentLoaded Event Listeners */
    document.addEventListener("DOMContentLoaded", function() {

      MicroModal.init();

      document.querySelectorAll("[data-js]").forEach(function(elem){
        elem.addEventListener("click", function(e) {
          var targetFn = window.Galea.Globals[elem.dataset.js];
            (typeof( targetFn ) == "function" && targetFn(e) )
        })
      });

      document.querySelectorAll(".gfield input, .gfield textarea").forEach(function(elem){
        elem.addEventListener("focusin", Form.labelHandler);
        elem.addEventListener("focusout", Form.labelHandler);
        elem.addEventListener("change", Form.labelHandler);
      });

      document.addEventListener('focusin', function (event) {
        if ( ! event.target.matches(".gfield input, .gfield textarea") ) return;
        else Form.labelHandler(event);
      }, false);

      document.addEventListener('focusout', function (event) {
        if ( ! event.target.matches(".gfield input, .gfield textarea") ) return;
        else Form.labelHandler(event);
      }, false);

      document.addEventListener('change', function (event) {
        if ( ! event.target.matches(".gfield input, .gfield textarea") ) return;
        else Form.labelHandler(event);
      }, false);

      jQuery(document).on('gform_post_render', function() {

        document.querySelectorAll(".gfield input, .gfield textarea").forEach(function(elem){

          console.dir($(elem));
          console.log($(elem).val().length);
        
          if($(elem).val().length >= 1) $(elem).closest(".gfield").find(".gfield_label").hide();
        });
        
      });
      if (sessionStorage["phoneShowing"] == 1) {
        $('body').addClass('showPhone');
      } else {
        setTimeout(function() {
          $('body').addClass('showPhone slowly');
          sessionStorage.setItem('phoneShowing', '1');
        }, 500);
      }
    }); /* END DOMContentLoaded */
    
}(jQuery, document, window));


